<template>
  <v-data-table :items="items" :headers="headers" :search="search">
    <template v-slot:item.duration="{ item }">
      {{
        `${item.duration} days/${Number(item.duration) - 1} Nights`
      }}</template
    >
    <template v-slot:item.description="{ item }">{{
      item && item.description && item.description.length > 50
        ? `${item.description.slice(0, 50)}...`
        : item.description
    }}</template>
    <template v-slot:item.marketPlace="{ item }">
      <v-simple-checkbox
        v-model="item.marketPlace"
        disabled
      ></v-simple-checkbox>
    </template>
    <template v-slot:item.actions="{ item }">
      <template-list-actions
        :item="item"
        @deleteItem="deleteItem"
        @editItem="editItem"
        @editItemContents="editItemContents"
        @showTemplateSettings="onShowTemplateSettings"
        @cloneItem="cloneItem"
      /> </template
  ></v-data-table>
</template>

<script>
import TemplateListActions from "./TemplateListActions.vue";
export default {
  components: { TemplateListActions },
  name: "templates-table",
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    headers: {
      type: Array,
      required: true,
      default: () => [],
    },
    search: {
      type: String,
      default: () => "",
    },
  },
  components: { TemplateListActions },

  methods: {
    deleteItem(payload) {
      this.$emit("deleteItem", payload);
    },
    editItem(payload) {
      this.$emit("editItem", payload);
    },
    editItemContents(payload) {
      this.$emit("editItemContents", payload);
    },
    onShowTemplateSettings(payload) {
      this.$emit("showTemplateSettings", payload);
    },
    cloneItem(payload) {
      this.$emit("cloneItem", payload);
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/templates/TemplatesTable.vue